function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#F5F5F5"
}, React.createElement("path", {
  d: "M317.977 1449.963c29.733-9.09 60.865 2.588 77.794 26.74l.509.735c3.97 5.663 7.172 12.001 9.408 18.912l.352 1.12-.177.054.097.327c10.606 36.792-9.92 75.403-46.35 87.19l-1.12.352-20.759-67.898.171-.052-.01-.031-67.282 20.57c-11.303-36.97 9.505-76.104 46.475-87.407l.342-.105-.043-.14.647-.192-.054-.175z",
  transform: "translate(-267 -1446)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 142,
    height: 140,
    viewBox: "0 0 142 140"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/figure-1.34697908.svg";
export { SvgComponent as ReactComponent };